import { ref, watchEffect } from 'vue'
import { jwt } from './jwt.js'
import { request } from './request.js'

const localStorageKey = 'mt_gdpr'

const cookies = {
    analytics: {
        display: 'Analytics',
        description:
            'These cookies are used for analytics on product usage to inform feature and performance improvements.',
    },
}

let stored = ref({ updated: null })

function persist() {
    if (Object.keys(stored.value).length > 0) {
        window.localStorage.setItem(localStorageKey, JSON.stringify(stored.value))
    } else {
        window.localStorage.removeItem(localStorageKey)
    }
}

function refresh() {
    try {
        stored.value = { updated: null, ...JSON.parse(window.localStorage.getItem(localStorageKey)) } || {
            updated: null,
        }
    } catch {
        stored.value = {}
        persist()
    }
}

refresh()

window.addEventListener('storage', e => {
    if (e.key === localStorageKey) {
        refresh()
    }
})

const gdpr = {
    acceptAll() {
        Object.keys(cookies).forEach(key => (stored.value[key] = true))
        stored.value.updated = new Date().toISOString()
        persist()
        refresh()
    },
    accept(params) {
        Object.entries(params).forEach(([key, value]) => {
            if (cookies[key]) {
                stored.value[key] = !!value
            }
        })
        stored.value.updated = new Date().toISOString()
        persist()
        refresh()
    },
    get all() {
        return Object.entries(cookies).map(([key, config]) => ({
            key,
            ...config,
            value: stored.value[key] ?? true,
        }))
    },
    get updated() {
        return stored.value.updated || null
    },
}

Object.keys(cookies).forEach(key =>
    Object.defineProperty(gdpr, key, {
        get() {
            return stored.value[key] ?? false
        },
        set(value) {
            stored.value[key] = value
            persist()
        },
    })
)

Object.freeze(gdpr)

export { gdpr }

watchEffect(() => {
    if (jwt.id > 0 && stored.value.updated && stored.value.reported !== stored.value.updated) {
        const payload = Object.fromEntries(Object.keys(cookies).map(key => [key, stored.value[key] ?? false]))
        stored.value.reported = stored.value.updated
        persist()

        request.post('/api/analytics/tracking-events/CookieOptOut', payload)
    }
})
